import { DelaysReportPage } from "./DelaysReportPage";

type Props = {};
const DelaysReport = (props: Props) => {
	return <DelaysReportPage />;
};
export default DelaysReport;
